import { createTheme } from '@mantine/core'

export const theme = createTheme({
  /** Put your mantine theme override here */

  primaryColor: 'brand',
  defaultRadius: 'md',
  fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
  },
  colors: {
    brand: [
      '#ebffff',
      '#d7fdfd',
      '#aafdfd',
      '#7dfdfc',
      '#62fcfc',
      '#56fcfc',
      '#4efdfc',
      '#41e1e1',
      '#30c8c8',
      '#002f2f'
    ],
  },
  primaryShade: { light: 6 },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Textarea: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
})
